import * as React from 'react';

function SvgEmptyDashboard(props) {
  return (
    <svg width={215} height={175} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.926 165.635c6.071 6.077 17.582 3.644 24.793-1.82 6.222-4.716 10.602-12.552 16.945-17.043 10.615-7.513 24.397-4.156 36.211 1.58 8.359 4.058 17.515 9.283 25.661 5.537 5.732-2.637 9.591-9.348 11.622-16.523.98-3.464 1.667-7.223 3.62-9.935 1.162-1.612 2.696-2.735 4.275-3.674 14.403-8.574 32.93-3.215 46.895-12.782 9.427-6.46 15.295-18.998 17.733-32.178 2.438-13.18 1.835-27.094.864-40.77-.691-9.719-1.782-20.104-6.922-27.741A23.062 23.062 0 00177.929.267c-8.148 1.265-15.452 6.41-21.842 12.55-7.993 7.661-15.347 17.28-25.287 20.188-6.771 1.98-13.964.579-21.003-.04-11.766-1.034-23.49.156-35.143 1.5-11.154 1.286-22.386 2.722-32.951 6.938-7.476 2.984-30.452 14.143-38.065 31.9-1.815 4.233-12.822 64.197 15.288 92.332z"
        fill="#E2F4F2"
      />
      <path
        d="M12 112v44M49 87v75M100 99v53M146 37v84M190 26v83"
        stroke="#D9D9D9"
        strokeWidth={2}
        strokeLinecap="round"
        strokeDasharray="2 4"
      />
      <g filter="url(#empty-dashboard_svg__filter0_d_54_680)">
        <rect x={20} y={9} width={72} height={64} rx={8} fill="#fff" />
      </g>
      <g filter="url(#empty-dashboard_svg__filter1_d_54_680)">
        <rect x={46} y={106} width={72} height={64} rx={8} fill="#fff" />
      </g>
      <circle cx={38} cy={29} r={8} fill="#6B92F3" />
      <rect x={30} y={43} width={52} height={6} rx={2} fill="#C2D7FF" />
      <rect x={101} y={118} width={6} height={40} rx={2} fill="#38B2A6" />
      <rect x={30} y={53} width={28} height={6} rx={2} fill="#C2D7FF" />
      <rect x={90} y={132} width={6} height={26} rx={2} fill="#ABD9D0" />
      <rect x={79} y={142} width={6} height={16} rx={2} fill="#ABD9D0" />
      <rect x={68} y={138} width={6} height={20} rx={2} fill="#ABD9D0" />
      <rect x={57} y={148} width={6} height={10} rx={2} fill="#ABD9D0" />
      <path
        d="M12 112l37-25 52 8 45.5-58.5 42.5-11"
        stroke="#BFBFBF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={190} cy={26} r={4} fill="#8C8C8C" />
      <circle cx={146} cy={37} r={4} fill="#8C8C8C" />
      <circle cx={100} cy={95} r={4} fill="#8C8C8C" />
      <circle cx={49} cy={87} r={4} fill="#8C8C8C" />
      <circle cx={12} cy={112} r={4} fill="#8C8C8C" />
      <g filter="url(#empty-dashboard_svg__filter2_d_54_680)">
        <rect x={107} y={53} width={104} height={40} rx={8} fill="#fff" />
      </g>
      <rect x={120} y={65} width={81} height={6} rx={2} fill="#FCCE01" />
      <rect x={120} y={75} width={40} height={6} rx={2} fill="#FEEA52" />
      <defs>
        <filter
          id="empty-dashboard_svg__filter0_d_54_680"
          x={16}
          y={6}
          width={80}
          height={72}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_54_680" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_54_680" result="shape" />
        </filter>
        <filter
          id="empty-dashboard_svg__filter1_d_54_680"
          x={42}
          y={103}
          width={80}
          height={72}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_54_680" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_54_680" result="shape" />
        </filter>
        <filter
          id="empty-dashboard_svg__filter2_d_54_680"
          x={103}
          y={50}
          width={112}
          height={48}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_54_680" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_54_680" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgEmptyDashboard;
